import { ArrowUpRight } from "lucide-react";
import { landingContent } from "../../data/landingContent";

export function GuidesSection() {
  const { guides } = landingContent;

  return (
    <section id="guides" className="st-section st-guides-section">
      <div className="st-container st-guides-heading">
        <p className="st-eyebrow">{guides.eyebrow}</p>
        <h2 className="st-heading-2">{guides.title}</h2>
        <p className="st-body-large">{guides.subtitle}</p>
      </div>
      <div className="st-container st-guides-grid">
        {guides.items.map((guide) => (
          <a key={guide.href} href={guide.href} className="st-guide-card">
            <span className="st-guide-card-icon" aria-hidden="true">
              <ArrowUpRight size={20} />
            </span>
            <span className="st-guide-card-title">{guide.title}</span>
            <span className="st-guide-card-description">
              {guide.description}
            </span>
            <span className="st-guide-card-link">{guides.readMore}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
